// Grid-related constants
export const GRID_SIZE = 50;
export const SNAP_GRID_SIZE = 25;

// Zoom constants
export const MIN_SCALE = 0.1;
export const MAX_SCALE = 5;
export const ZOOM_FACTOR_IN = 1.1;
export const ZOOM_FACTOR_OUT = 0.9;

// Card and deck dimensions
export const CARD_WIDTH = 126;
export const CARD_HEIGHT = 176;
export const ZOOMED_CARD_WIDTH = 567;
export const ZOOMED_CARD_HEIGHT = 792;

// Performance
export const DRAG_DEBOUNCE_THRESHOLD = 16; // ms (roughly 60fps)
export const POSITION_THRESHOLD = 5; // px - minimum movement to trigger an update

// Notification
export const NOTIFICATION_DURATION = 2000; // ms 

// History
export const MAX_HISTORY_ENTRIES = 50;
